module.exports = __webpack_public_path__ + "static/img/home-4.8cd259f6.jpg";